import React from "react";
import BackToTop from "views/BackToTop";
import archywavelogo from "assets/img/archywavelogo.png"
import archywavelogoss from "assets/img/archywavelogoss.png";
import opera from "assets/img/imagess/opera.webp";
import archywavedubai from "assets/img/imagess/archywavedubai.webp"

export default function Footer() {
  return (
    <>


      <footer className="container mx-auto xl:mt-32 px-4">
        <div className="w-full">
          <div className="flex flex-wrap mt-12">
            <div className="xl:w-5/12 lg:w-4/12 md:w-6/12">
              <img src={archywavelogoss} className="text-black fontfamily xl:text-2xl font-medium xl:w-80">

              </img>
              <p className="text-black fontfamily xl:text-xl text-justify font-medium mt-6 xl:w-8/12" style={{color: '#747272'}}>
                We believe that our team is able to deliver the best assistance together with 3D
                visualisation and IT services of the highest quality.
              </p>
            </div>
            <div className="xl:w-4/12 lg:w-5/12 md:w-6/12 xl:px-6 xl:mt-0 lg:mt-2  md:mt-1 lg:px-10 md:px-12 mt-12">
              <h1 className="fontfamily  uppercase text-black font-semibold xl:text-2xl text-xl mb-6" style={{color: '#747272'}}>
                Contact Details
              </h1>
            <div className="">
                  <div className="flex items-center justify-start text-left">
                    <div className="justify-start  ">
                      <img src={opera} alt="" className="w-8 " />
                    </div>
                    <p className="fontfamily uppercase text-black xl:text-lg font-semibold pl-3" style={{color: '#747272'}}>
                      Australia
                    </p>
                  </div>
                  <div className="text-left mt-2 xl:text-lg font-semibold" style={{color: '#747272'}}>
                    Phone : <span className="text-black font-semibold" style={{color: '#747272'}}> +61493165725 </span>
                  </div>
                  <div className="mt-2 xl:text-lg font-semibold" style={{color: '#747272'}}>
                    Email  : <span className="text-black font-semibold" style={{color: '#747272'}}> info@archywave.com </span>
                  </div>

                
                  <div className="pt-6 mt-2 text-left">
                  <div className="flex items-center justify-start ">
                    <div className="justify-start ">
                      <img src={archywavedubai} alt="" className="w-8 " />
                    </div>
                    <p className="fontfamily uppercase text-black xl:text-lg font-semibold pl-3" style={{color: '#747272'}}>
                      UAE
                    </p>
                  </div>
                  <div className="mt-2 xl:text-lg font-semibold" style={{color: '#747272'}}>
                    Phone : <span className="text-black font-semibold" style={{color: '#747272'}}> +61493165725 </span>
                  </div>
                  <div className="mt-2 xl:text-lg font-semibold" style={{color: '#747272'}}>
                    Email  : <span className="text-black font-semibold" style={{color: '#747272'}}> info@archywave.com </span>
                  </div>
                </div>
                </div>
            </div>


            <div className="xl:w-3/12 lg:3/12 xl:mt-0 mt-12 lg:mt-2">
            <h1 className="fontfamily uppercase text-black font-semibold xl:text-2xl text-xl mb-6" style={{color: '#747272'}}>
                Follow Us
              </h1>
              <div className="flex items-center ">
                <div className="">
                  <i className="fab fa-facebook xl:text-2xl" ></i>
                </div>
                <div className="px-4">
                  <a href="http://www.youtube.com/@archywavepvtltd">
                  <i className="fab fa-youtube xl:text-2xl"></i>
                  </a>
                </div>
                <div className="">
                  <i className="fab fa-instagram xl:text-2xl"></i>
                </div>
                <div className="px-4">
                  <a href="https://www.linkedin.com/company/archywave-pvt-ltd/about/?viewAsMember=true">
                  <i className="fab fa-linkedin xl:text-2xl"></i>
                  </a>
                </div>
                <div className="">
                  <i className="fab fa-behance xl:text-2xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full xl:mt-12 mt-6 mb-6 border-t">
          <div className="flex flex-wrap justify-between items-center">
            <div className="xl:w-4/12">
              <div className=" justify-evenly">

              
                <h2 className="xl:mt-0 mt-4 text-black fontfamily xl:text-sm text-sm" style={{color: '#747272'}}>
                Copyright © 2024 Archywave. All Rights Reserved
                </h2>

              </div>
            </div>
            <div className="xl:w-6/12 w-12  justify-end text-right ">
              <BackToTop />
            </div>
          </div>
        </div>

        {/* <div className="flex flex-wrap mt-12">
          <div className="xl:w-6/12">
            <img src={archywavelogo} className="text-black fontfamily xl:text-2xl font-medium xl:w-80">

            </img>
            <p className="text-black fontfamily xl:text-xl font-medium mt-6 xl:w-8/12">
              We believe that our team is able to deliver the best assistance together with 3D
              visualisation and IT services of the highest quality.
            </p>


            <p className="text-black fontfamily xl:text-xl font-light mt-16 uppercase">
              <a href="/home">
                Who We Are
              </a>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light pt-2 uppercase">
              <a href="/projects">
                Packages
              </a>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light pt-2 uppercase">
              <a href="/who-we-are">
                What We Do
              </a>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light pt-2 uppercase">
              <a href="/contact">
                Work
              </a>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light pt-2 uppercase">
              <a href="/contact">
                Why
              </a>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light pt-2 uppercase">
              <a href="/contact">
                Contact Us
              </a>
            </p>
          </div>
          <div className="xl:w-6/12 text-right">
            <p className="text-black fontfamily xl:text-xl font-light flex justify-end items-center">
              Facebook <img src="https://i.ibb.co/CmcXrFQ/right-down.png" alt="" className=" h-5 pl-4"></img>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light flex justify-end items-center mt-3">
              LinkedIn <img src="https://i.ibb.co/CmcXrFQ/right-down.png" alt="" className=" h-5 pl-4"></img>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light flex justify-end items-center mt-3">
              Instagram <img src="https://i.ibb.co/CmcXrFQ/right-down.png" alt="" className=" h-5 pl-4"></img>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light flex justify-end items-center mt-3">
              Youtube <img src="https://i.ibb.co/CmcXrFQ/right-down.png" alt="" className=" h-5 pl-4"></img>
            </p>
            <p className="text-black fontfamily xl:text-xl font-light flex justify-end items-center mt-3">
              Behance <img src="https://i.ibb.co/CmcXrFQ/right-down.png" alt="" className=" h-5 pl-4"></img>
            </p>

            <div className="flex justify-between">
              <div className="xl:w-8/12"></div>
              <div className="xl:w-4/12">
                <div className="xl:mt-12">
                  <div className="flex items-center justify-start text-left">
                    <div className="justify-start  ">
                      <img src="https://i.ibb.co/P1RtNvv/archywavesydney.png" alt="" className="w-8 " />
                    </div>
                    <p className="fontfamily uppercase text-black xl:text-xl">
                      Australia
                    </p>
                  </div>
                  <div className="text-left mt-2 xl:text-lg font-semibold" style={{ color: '#3d5975' }}>
                    Phone : <span className="text-black font-semibold"> +61493165725 </span>
                  </div>
                </div>

                <div className="pt-6 text-left">
                  <div className="flex items-center justify-start ">
                    <div className="justify-start ">
                      <img src="https://i.ibb.co/7S6KV3k/archywavedubai.png" alt="" className="w-8 " />
                    </div>
                    <p className="fontfamily uppercase text-black xl:text-xl">
                      UAE
                    </p>
                  </div>
                  <div className="mt-2 xl:text-lg font-semibold" style={{ color: '#3d5975' }}>
                    Phone : <span className="text-black font-semibold"> +61493165725 </span>
                  </div>
                  <div className="mt-2 xl:text-sm font-semibold" style={{ color: '#3d5975' }}>
                    Email  : <span className="text-black font-semibold"> info@acrhywave.com </span>
                  </div>
                </div>
              </div>
            </div>

          </div>


        </div>


        <div className="w-full mt-24 mb-6">
          <div className="flex flex-wrap justify-between mt-16 items-center">
            <div className="xl:w-4/12">
              <div className="flex justify-between">

              
                <h2 className="text-black fontfamily xl:text-sm">
                Copyright © 2024 Archywave. All Rights Reserved
                </h2>

              </div>
            </div>
            <div className="xl:w-6/12 justify-end text-right ">
              <BackToTop />
            </div>
          </div>
        </div> */}
      </footer>
      {/* <footer className="relative bg-blueGray-200 pt-8 pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
              <h5 className="text-lg mt-0 mb-2 text-blueGray-600">
                Find us on any of these platforms, we respond 1-2 business days.
              </h5>
              <div className="mt-6 lg:mb-0 mb-6">
                <button
                  className="bg-white text-lightBlue-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-twitter"></i>
                </button>
                <button
                  className="bg-white text-lightBlue-600 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-facebook-square"></i>
                </button>
                <button
                  className="bg-white text-pink-400 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-dribbble"></i>
                </button>
                <button
                  className="bg-white text-blueGray-800 shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2"
                  type="button"
                >
                  <i className="fab fa-github"></i>
                </button>
              </div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/presentation?ref=nr-footer"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://blog.creative-tim.com?ref=nr-footer"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.github.com/creativetimofficial?ref=nr-footer"
                      >
                        Github
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://www.creative-tim.com/bootstrap-themes/free?ref=nr-footer"
                      >
                        Free Products
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Other Resources
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://github.com/creativetimofficial/notus-react/blob/main/LICENSE.md?ref=nr-footer"
                      >
                        MIT License
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/terms?ref=nr-footer"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/privacy?ref=nr-footer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/contact-us?ref=nr-footer"
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-blueGray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-blueGray-500 font-semibold py-1">
                Copyright © {new Date().getFullYear()} Notus React by{" "}
                <a
                  href="https://www.creative-tim.com?ref=nr-footer"
                  className="text-blueGray-500 hover:text-blueGray-800"
                >
                  Creative Tim
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </footer> */}
    </>
  );
}
